import { sandboxUseCasesFlat } from 'app/constants/usecaseContants';
import ShareIcon from 'components/Icons/ShareIcon';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import styleConstants from 'styles/style-constants';
export var NameColumn = function (_a) {
    var data = _a.data;
    var useCaseName = data.usecase;
    sandboxUseCasesFlat.some(function (item) {
        if (item.name === useCaseName) {
            useCaseName = item.long_name;
            return true;
        }
        return false;
    });
    var invitedUsersCount = data.invitedUsers ? data.invitedUsers.length : 0;
    var pendingInvitesCount = data.pendingInvites ? data.pendingInvites.length : 0;
    return (React.createElement("span", null,
        React.createElement("span", null, useCaseName),
        invitedUsersCount + pendingInvitesCount > 0 && (React.createElement(Popup, { inverted: true, position: "bottom center", trigger: React.createElement("span", { className: "pl2" },
                React.createElement(ShareIcon, { color: styleConstants.colors.aluminum, size: 18, viewBox: undefined })) },
            React.createElement("span", { className: "font-x-small" }, data.sbRel === 'IS_GRANTED_ACCESS_TO'
                ? 'You were invited to this project'
                : "Shared with ".concat(invitedUsersCount + pendingInvitesCount, " people"))))));
};
export default NameColumn;
